export const options = {
  template: 'lodash',
  ajax: true,
  iconlib: 'lxp',
  theme: 'lxp',
  disable_edit_json: true,
  disable_array_delete_all_rows: true,
  disable_array_delete_last_row: true,
  disable_collapse: true,
  required_by_default: true,
  no_additional_properties: true,
  array_controls_top: true,
  collapsed: false,
  expand_height: true,
  // object_layout: 'categories', // todo: explore categories layout as a toggleable "compact" option
  show_errors: 'never',
  use_default_values: true,
  remove_empty_properties: false,
  assets: { },
  datasets: { }
}

export default {
  options
}
